import React from 'react';

import { installedState } from '../../utils/packageInstalls';

/**
 * Whether the person already has this package (keepr-api KPR-364, epic
 * KPE-035): *Installed* when any collection they can read holds the whole
 * bundle, *Installed (6 of 7 cards)* when the collection that holds most of it
 * has lost some of its cards (KPR-1135); a collection with no live card of it
 * is not installed and not listed. *Update available* INSTEAD when a
 * collection they manage is behind (ruling Q7 — a reader of a collection that
 * is behind sees *Installed*, as the server sends them no `updateAvailable`).
 * The update chip is the screen's one accent (`--action`); the installed chip
 * is neutral. Nothing for a package the person does not hold.
 */
export default function InstalledBadge({ pkg, className = '' }) {
	const { installed, behind, partial, words } = installedState(pkg);
	if (!installed) return null;
	const state = behind ? 'update' : (partial ? 'partial' : 'installed');
	const classes = ['installed-badge', behind ? 'installed-badge--update' : '', className].filter(Boolean).join(' ');
	return (
		<span className={classes} data-state={state}>
			{behind ? 'Update available' : words}
		</span>
	);
}
